// extracted by mini-css-extract-plugin
export default {"main":"BlogPage_main__yO7cG","searchWrap":"BlogPage_searchWrap__c33eU","search":"BlogPage_search__j2--q","grid":"BlogPage_grid__3G7-5","pagination":"BlogPage_pagination__FqvZp"};